import { render, staticRenderFns } from "./combinationCourse.vue?vue&type=template&id=a6a33df4&scoped=true&"
import script from "./combinationCourse.vue?vue&type=script&lang=js&"
export * from "./combinationCourse.vue?vue&type=script&lang=js&"
import style0 from "./combinationCourse.vue?vue&type=style&index=0&id=a6a33df4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a33df4",
  null
  
)

export default component.exports